import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { getFaqCategoryUser } from "../../redux/templete/authSlice";

function HelpModal() {
  const { userFaqCategory } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFaqCategoryUser());
  }, [dispatch]);
  return (
    <div className="w-full py-10 max-w-[1000px]">
      <h1 className="text-[3rem] font-bold mb-4 text-black">
        Hi there, how can we help?
      </h1>

      {/* <div className=" flex flex-col gap-6">
        {faqSections.map((section, sectionIndex) => (
          <div key={sectionIndex} className="flex flex-col gap-2">
            <h2 className="text-lg font-bold opacity-70">{section.header}</h2>
            {section.faqs.map((faq, faqIndex) => (
              <div key={faqIndex} className="px-2">
                <div
                  className="hover:bg-slate-200 p-1 px-2 rounded-lg flex flex-row flex-nowrap justify-between items-center cursor-pointer"
                  onClick={() => toggleVisibility(sectionIndex, faqIndex)}
                >
                  <h3 className="text-xl font-semibold">
                    Q{faqIndex + 1}: {faq.question}
                  </h3>
                  <span>
                    <FaChevronDown />
                  </span>
                </div>
                {visibleItems[sectionIndex]?.[faqIndex] && (
                  <div className="pl-4">
                    <p>
                      A{faqIndex + 1}: {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div> */}

      <div className="flex flex-col gap-3 mb-6">
        {userFaqCategory !== null &&
          userFaqCategory
            .filter((category) => category._id !== "67f7630620d1aa72a0ad6731")
            .map((category) => (
              <NavLink
                to={
                  "articles/" +
                  category._id +
                  "-" +
                  category.name.replace(/\s+/g, "-")
                }
                className="border rounded-lg w-full  p-4 flex flex-row gap-2 items-center transition-shadow duration-200 ease-out hover:shadow-[0_2px_12px_rgba(36,63,97,0.11),0_0.5px_2px_rgba(36,63,97,0.12)]"
              >
                <span className="text-base w-[95%] overflow-hidden text-ellipsis whitespace-nowrap text-left">
                  {category.name}
                </span>
                <span className="font-semibold text-lg">
                  <MdOutlineKeyboardArrowRight />
                </span>
              </NavLink>
            ))}
      </div>

      <span className=" text-lg font-bold mb-4 text-black">
        Can't find what you're looking for?
      </span>
      <div className="flex flex-col gap-3 mb-6">
        <NavLink
          to={"articles/67f7630620d1aa72a0ad6731-በአማርኛ"}
          className="border rounded-lg w-full  p-4 flex flex-row gap-2 items-center transition-shadow duration-200 ease-out hover:shadow-[0_2px_12px_rgba(36,63,97,0.11),0_0.5px_2px_rgba(36,63,97,0.12)]"
        >
          <span className="text-base w-[95%] overflow-hidden text-ellipsis whitespace-nowrap text-left">
            በአማርኛ
          </span>
          <span className="font-semibold text-lg">
            <MdOutlineKeyboardArrowRight />
          </span>
        </NavLink>
        <NavLink
          to={"/contact-us"}
          className="border rounded-lg w-full  p-4 flex flex-row gap-2 items-center transition-shadow duration-200 ease-out hover:shadow-[0_2px_12px_rgba(36,63,97,0.11),0_0.5px_2px_rgba(36,63,97,0.12)]"
        >
          <span className="text-base w-[95%]">Chat with us</span>
          <span className="font-semibold text-lg">
            <MdOutlineKeyboardArrowRight />
          </span>
        </NavLink>
      </div>
    </div>
  );
}

export default HelpModal;
